if($('table.total-ticket tbody select.nbSeat').length > 0 ) {
  $('table.total-ticket tbody select.nbSeat').live('change', function(){
    var nbTicket = $(this).val();
    var $table = $(this).parents('table');
    var price = $(this).parents('tr').find('.price span.val span').text();
    var hasPromoPrice = $(this).parents('tr').find('.price span.promo-price').text();
    var promoPrice = $(this).parents('tr').find('.price span.promo-price span').text();
    var globalPromoPriceFixe = $('.promo-payment .value-fixe').text();
    var globalPromoPricePercent = $('.promo-payment .value-percent').text();
    var globalPromoPriceFree = $('.promo-payment .value-free').text();
    var limitPromo = $(this).parents('tr').find('.price span.promo-price').data('limit');
    var $total = $(this).parents('tr').find('.total .change_price');
    var $totalPromo = $(this).parents('tr').find('.total span.promo-price span');
    var $grandTotal = $table.find('tfoot .grandtotal span');
    var grandTotal = 0;
    var grandTotalPromo = 0;
    var promo = 0;

    if (price == '') {
       return;
    }
    if (!hasPromoPrice) {
       promoPrice = 0;
    }
  
    var total = nbTicket * price
    if(limitPromo) {
        var withoutPromo = nbTicket > limitPromo ? nbTicket - limitPromo : 0;
        var totalPromo = ((nbTicket - withoutPromo) * promoPrice) + (withoutPromo * price); 
    } else {
        var totalPromo = nbTicket * promoPrice;           
    }


    $total.text(total.toFixed(2));
    if (totalPromo == 0 && !hasPromoPrice || nbTicket <= 0 || totalPromo < 0 ) {
       $totalPromo.parent().hide();
       $total.parent().parent().removeClass('barre');
    }
    else {
       $totalPromo.text(totalPromo.toFixed(2));
       $totalPromo.parent().show();
       $total.parent().parent().addClass('barre');
    }
   
    $table.find('tbody .total .promo-price span').each(function(){
        grandTotalPromo = grandTotalPromo + parseFloat($(this).text());
        if (parseFloat($(this).parent().parent().find('.change_price').text()) > 0) {
            promo += (parseFloat($(this).parent().parent().find('.change_price').text()) - parseFloat($(this).text()));
        }
    });

   $table.find('tbody .total .change_price').each(function(){
       grandTotal = grandTotal + parseFloat($(this).text());
   });

    if (grandTotalPromo >= 0) {
       grandTotal = grandTotal - promo;
    }

    if (promo > 0) {
       $table.find('.promo-reduc').show();
       $table.find('.promo-reduc span').text('-' + promo.toFixed(2));
    }
    else {
       $table.find('.promo-reduc').hide();
       $table.find('.promo-reduc span').text(0);
    } 
   
    
    if(globalPromoPriceFixe || globalPromoPricePercent || globalPromoPriceFree) {
      if(globalPromoPriceFixe) {
        reduc = globalPromoPriceFixe;
      } else if (globalPromoPricePercent) {
        reduc = grandTotal * (globalPromoPricePercent/100)
      } else if (globalPromoPriceFree) {
        reduc = grandTotal
      }
      newGrandTotal = grandTotal-reduc > 0 ? grandTotal-reduc : 0;        
      $grandTotal.text(newGrandTotal.toFixed(2));
      if(reduc > 0) {
        $table.find('.promo-reduc').show();
        $table.find('.promo-reduc span').text('-' + reduc.toFixed(2));  
      } else {
        $table.find('.promo-reduc').hide();
        $table.find('.promo-reduc span').text(0);
      }
    } else {
      $grandTotal.text(grandTotal.toFixed(2));
    }
});
}